import { useEffect, useCallback, useRef } from 'react';
import { useCurrentProjectId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { OP_STATUSES } from '@common/constants';
import { buildCreateProjectUsersRequest } from '../utils';
import { ACTIONS } from '../state/actions';

const useCreateProjectUsers = ({
  onSubmit,
  dispatch,
  useWriteConstructionApis,
}) => {
  const projectId = useCurrentProjectId();
  const latestOnSubmit = useRef(onSubmit);

  // Create Project Users
  const {
    data: createProjectUsersData,
    error: createProjectUsersError,
    doFetch: doCreateProjectUsersFetch,
  } = useDataApi();

  const createProjectUsersRequest = useCallback(
    ({ emails, access }) => {
      const usersData = { users: [] };

      emails.forEach((email, index) => {
        usersData.users[index] = {
          email: email.label,
          [useWriteConstructionApis ? 'products' : 'services']: access,
        };
      });

      doCreateProjectUsersFetch(
        ...buildCreateProjectUsersRequest(
          projectId,
          usersData,
          useWriteConstructionApis
        )
      );
    },
    [doCreateProjectUsersFetch, projectId, useWriteConstructionApis]
  );

  useEffect(() => {
    latestOnSubmit.current = onSubmit;
  }, [onSubmit]);

  // Handle create project users error
  useEffect(() => {
    if (createProjectUsersError === null) return;

    latestOnSubmit.current({
      status: OP_STATUSES.ERROR,
      response: createProjectUsersError,
    });
    dispatch({
      type: ACTIONS.SET_IS_SAVING,
      payload: false,
    });
  }, [createProjectUsersError, dispatch]);

  // Handle create project users success
  useEffect(() => {
    if (createProjectUsersData === null) return;

    dispatch({
      type: ACTIONS.SET_ARE_USERS_INVITED,
      payload: true,
    });
    dispatch({
      type: ACTIONS.SET_IS_SAVING,
      payload: false,
    });
    latestOnSubmit.current({ status: OP_STATUSES.SUCCESS });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createProjectUsersData]);

  return {
    createProjectUsersRequest,
  };
};

export default useCreateProjectUsers;
